<div class="product-article">
  <div class="field">
    <div class="field-text">
      {{ article() }}
    </div>
  </div>
  <div class="field">
    <div class="field-text">
      {{ productName() }}
    </div>
  </div>
</div>
